import React from 'react';
import { useSelector } from 'react-redux';
import { QualityControlApi } from '@Data/qualityControl/Api';
import { IAnalysisEntity } from '@Data/qualityControl/Interfaces';
import {
    analysisEntitiesState,
    selectedAnalysisEntityState,
} from '@Data/qualityControl/Reducer';
import Symbology from '@Views/QualityControl/styles/symbology.scss';
import { QcEntitiesTable } from './QcEntitiesTable';

export const EntitiesList = () => {
    const analysisEntities = useSelector(analysisEntitiesState);
    const selectedEntity = useSelector(selectedAnalysisEntityState);

    const handleSetEntity = (entity: IAnalysisEntity) => {
        QualityControlApi.setSelectedAnalysisEntity(entity);
    };

    return (
        <QcEntitiesTable
            data={analysisEntities}
            selectedEntity={selectedEntity}
            onSetQcEntity={handleSetEntity}
            disableReworkReason
            selectedRowBackgroundColor={Symbology.centerPole}
        />
    );
};
